<div class="title-container">
  <h6 class="dx-theme-background-color-as-text-color">{{upperTitle}}</h6>
  <h4 class="dx-theme-background-color-as-text-color">{{routeTitle | translate}}</h4>
</div>
